module.exports = __webpack_public_path__ + "img/tiger_logo.4f68e40d.jpg";